/* DowPickerRenderer.js */

"use strict";
const _ = require("lodash");
const ComboBoxControl = require("@gluenetworks/combobox").Single;
const BaseSubComponentScheduleRenderer = require("../../base/BaseSubComponentScheduleRenderer");

const DaysOfWeek = {
    Mon: 2,
    Tue: 3,
    Wed: 4,
    Thu: 5,
    Fri: 6,
    Sat: 7,
    Sun: 1,
};
const DaysOfWeekOptions = [
    {label: "Monday", value: 2},
    {label: "Tuesday", value: 3},
    {label: "Wednesday", value: 4},
    {label: "Thursday", value: 5},
    {label: "Friday", value: 6},
    {label: "Saturday", value: 7},
    {label: "Sunday", value: 1},
];

class DowPickerRenderer extends BaseSubComponentScheduleRenderer {
    constructor(model) {
        super(model, "dow-picker-gl");
        this._dayLabels = [];
        if (model.getSchedule().type === "dow" || model.getSchedule().type === "avail") {
            this._selectedDays = model.getSchedule().dow ? _.clone(model.getSchedule().dow) : [];
        } else {
            this._selectedDay = model.getSchedule().dow || 2;
        }
    }
    render() {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                if (this._selectedDays) {
                    this._childDowLabelElements = [];
                    this._dowsContainerElem = document.createElement("dows-container");
                    _.forEach(DaysOfWeek, (dayNum, dayName) => {
                        let dowLabelElem = document.createElement(dayName);
                        dowLabelElem.classList.add("inline-element-gl");
                        dowLabelElem.classList.add("day-picker-gl");
                        dowLabelElem.innerHTML = dayName;
                        this._dayLabels[dayNum] = dowLabelElem;
                        dowLabelElem.addEventListener(
                            "click",
                            (this._onDayLabelClick = this._onDayLabelClick.bind(this))
                        );
                        this._childDowLabelElements.push(dowLabelElem);
                        this._dowsContainerElem.appendChild(dowLabelElem);
                    });
                    this._rootElem.appendChild(this._dowsContainerElem);
                } else {
                    this._dowComboComp = new ComboBoxControl({
                        options: DaysOfWeekOptions,
                        showFilter: false,
                        adjustWidth: true,
                    });
                    this._rootElem.appendChild(this._dowComboComp.renderer.rootElement);
                    this._dowComboComp.on("UserValue", (this._onDow = this._onDow.bind(this)));
                    return this._dowComboComp.renderer.render();
                }
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        if (this._dowsContainerElem) {
            return this._childDowLabelElements.concat(this._dowsContainerElem);
        } else {
            return [this._dowComboComp];
        }
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                let shutdownPromises = [super.shutdown()];
                if (this._dowComboComp) {
                    shutdownPromises.push(this._dowComboComp.shutdown());
                }
                return shutdownPromises;
            })
            .then(() => {
                if (this._dowsContainerElem) {
                    this._dowsContainerElem.remove();
                    this._dowsContainerElem = undefined;
                    this._dayLabels = undefined;
                    this._childDowLabelElements = undefined;
                } else {
                    this._dowComboComp = undefined;
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        super._registerListeners();
    }
    _unregisterListeners() {
        super._unregisterListeners();
        if (this._dayLabels) {
            this._dayLabels.forEach((dayLabel) => {
                dayLabel.removeEventListener("click", this._onDayLabelClick);
            });
        } else {
            this._dowComboComp.removeEventListener("UserValue", this._onDow);
        }
    }
    _onDow() {
        this._model.setScheduleProp("dow", this._dowComboComp.getValue(), true);
    }
    _onDayLabelClick(e) {
        let dayLabelElem = e.target;
        let dayName = dayLabelElem.innerHTML;
        let dayNum = DaysOfWeek[dayName];
        this._setDaySelected(dayLabelElem, dayNum, !this._isDaySelected(dayNum), true);
    }
    _setControlValuesFromModel() {
        if (this._selectedDays) {
            this._dayLabels.forEach((dayLabelElem, dayNum) => {
                if (this._model.theme) {
                    dayLabelElem.classList.add(this._model.theme);
                }
                this._setDaySelected(dayLabelElem, dayNum, this._isDaySelected(dayNum), false);
            });
        } else {
            this._dowComboComp.setValue(this._model.getSchedule().dow);
        }
    }
    _setDaySelected(dowLabelElem, dayNum, selected, setByUser) {
        if (selected) {
            dowLabelElem.classList.add("selected-day");
        } else {
            dowLabelElem.classList.remove("selected-day");
        }
        _.remove(this._selectedDays, (selDayNum) => {
            return selDayNum === dayNum;
        });
        if (selected) {
            this._selectedDays.push(dayNum);
        }
        this._model.setScheduleProp("dow", this._selectedDays, setByUser);
    }
    _isDaySelected(dayNum) {
        return _.find(this._selectedDays, (selDayNum) => {
            return selDayNum === dayNum;
        });
    }
}
module.exports = DowPickerRenderer;
